import { render, staticRenderFns } from "./SettingsManagersPage.vue?vue&type=template&id=50a76550"
import script from "./SettingsManagersPage.vue?vue&type=script&lang=ts"
export * from "./SettingsManagersPage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsManagersPage.vue?vue&type=style&index=0&id=50a76550&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports